"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
var bech32 = __importStar(require("bech32"));
var Hash_1 = require("../../Consensus/Types/Hash");
var ContractId_1 = require("../../Consensus/Types/ContractId");
var Address;
(function (Address) {
    function getChainType(chain) {
        switch (chain) {
            case 'test':
                return 'tzn';
            case 'main':
                return 'zen';
            default:
                return 'tzn';
        }
    }
    Address.getChainType = getChainType;
    function decode(chain, address) {
        var _a = bech32.decode(address), prefix = _a.prefix, words = _a.words;
        if (words[0] !== 0)
            throw new Error('invalid version');
        var data = Buffer.from(bech32.fromWords(words.slice(1)));
        if (prefix.length === 3 && prefix === getChainType(chain)) {
            var pkHash = Hash_1.Hash.read(data, 0).hash;
            return pkHash;
        }
        else if (prefix.length === 4 && prefix === ('c' + getChainType(chain))) {
            return ContractId_1.ContractId.fromString(data.toString('hex'));
        }
        else {
            throw new Error('not supported');
        }
    }
    Address.decode = decode;
    function getPublicKeyHashAddress(chain, hash) {
        var buffer;
        if (typeof hash === 'string') {
            buffer = Buffer.from(hash, 'hex');
        }
        else if (hash instanceof Hash_1.Hash) {
            buffer = hash.bytes;
        }
        else if (hash instanceof ContractId_1.ContractId) {
            buffer = hash.stringBuffer();
        }
        else
            buffer = hash;
        var words = bech32.toWords(buffer);
        var withVersion = Buffer.alloc(words.length + 1);
        withVersion.writeInt8(0, 0);
        Buffer.from(words).copy(withVersion, 1);
        var hrp = getChainType(chain);
        if (hash instanceof ContractId_1.ContractId)
            hrp = 'c' + hrp;
        return bech32.encode(hrp, withVersion);
    }
    Address.getPublicKeyHashAddress = getPublicKeyHashAddress;
})(Address = exports.Address || (exports.Address = {}));
exports.default = Address;
//# sourceMappingURL=Address.js.map